import { EUserRoles } from '../enums/roles'
import { useUserSelector } from '../store/selectors/auth'

const usePermissions = (roles: EUserRoles[]) => {
  const user = useUserSelector()
  return user ? roles.includes(user.role) : false
}

export default usePermissions
